module.exports = __webpack_public_path__ + "img/22010____-7.prt.5d20a332.jpg";